import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';

import messages from '../../assets/locale/messages_en.json';
import Router from '../../router';
import { Heading, WixDesignSystemProvider } from '@wix/design-system';

class ErrorBoundary extends React.Component<
  {},
  { hasError: boolean; error: string }
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: '' };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, error });
    console.error(error, info);
  }

  render() {
    const { hasError } = this.state;
    if (hasError) {
      return (
        <>
          <Heading>Something went wrong.</Heading>
        </>
      );
    }

    return this.props.children;
  }
}

const RootContainer = ({ store }) => {
  return (
    <ErrorBoundary>
      <WixDesignSystemProvider>
        <Provider store={store}>
          <IntlProvider locale="en" messages={messages}>
            <Router />
          </IntlProvider>
        </Provider>
      </WixDesignSystemProvider>
    </ErrorBoundary>
  );
};

export default RootContainer;
